export default __webpack_public_path__ + "static/media/flag-mongolia.b405c259.svg";